module.exports = __webpack_public_path__ + "static/media/practice-shade3.0e172dff.svg";